const modifyField = (instance, field, value) => (Object.assign(Object.assign({}, instance), { [field]: value }));
export default modifyField;
